<template>
    <div class="overflow-auto">
      <table ref="myTable" class="table table-bordered position-relative" width="100%">
        <tr v-if="isLoading">
          <td colspan="7">
            <div class="dot-loading mt-3">
              <ul class="loader-circle">
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </td>
        </tr>
      </table>
    </div>
    
  </template>
  
  <script>
  import CreateAccount from '@/services/CreateAccount';
  import $ from 'jquery';
  import 'datatables.net';
  import 'datatables.net-bs4';
  import 'datatables.net-responsive';
  
  import "datatables.net-buttons/js/dataTables.buttons.js"
  import "datatables.net-buttons/js/buttons.colVis.js"
  import "datatables.net-buttons/js/buttons.flash.js"
  import "datatables.net-buttons/js/buttons.html5.js"
  import "datatables.net-buttons/js/buttons.print.js"
  
  const baseURL = (process.env.VUE_APP_ENVIRONMENT == "production")?
    "https://gep-api.cgtechnology.io":(process.env.VUE_APP_ENVIRONMENT == "development"?
      "https://gep-api.cgtechnology.io":"https://gep-api.cgtechnology.io");
  const token = localStorage.getItem('token');
  
  const STATUS = {
    1:"Processing",
    2:"Approved",
    3:"Rejected"
  };
  
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
        isLoading:false,
        dataTable: null
      };
    },
    props:['userNo'],
    methods: {
      handleSubAccount(event){
        var data = this.dataTable.row($(event.target).closest('tr,li')).data();
        this.$emit('sub-account',data);
      },
      checkError(err){
        const response = err.response;
        try{
            if(response.status == 401 && response.data.name == "Unauthorized"){
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                this.$router.push({ 
                  path: '/login', 
                });
            }
            else{
                if(localStorage.getItem("token")){
                var msg = (response.data)?response.data.message:err.message;
                this.$notify({
                    type: 'warn',
                    text: msg
                })
                }
            }
        }catch(e){
          console.log(err);
        }        
      }
    },
    mounted() {
      let self = this;
      this.$nextTick(() => {
        self.isLoading = true;
        this.dataTable = $(this.$refs.myTable).DataTable({
          dom: 'lBfrpit',
          "bLengthChange" : false,
          "bInfo":true,  
          order: [
              [4, 'desc']
          ],
            buttons: [
                {
                    extend: 'copy',
                    text: '<div class="d-flex align-items-center"><i class="fa-regular fa-copy"></i> <span class="mx-auto">'+this.$t("Copy")+'</span></div>',
                    titleAttr: 'CSV'
                },{
                    extend: 'csv',
                    text: '<div class="d-flex align-items-center"><i class="fa-solid fa-file-csv"></i> <span class="mx-auto">'+this.$t("Download")+'</span></div>',
                    titleAttr: 'CSV'
                },{
                    extend: 'print',
                    text: '<div class="d-flex align-items-center"><i class="fa-solid fa-print"></i> <span class="mx-auto">'+this.$t("Print")+'</span></div>',
                    titleAttr: 'Print'
                }],
          // responsive: true, // Enable the Responsive extension
          searching: true,
          pagingType: "simple",
          language: {
            info: '_START_-_END_ of _TOTAL_',
            infoEmpty: this.$t('Showing 0 to 0 of 0 entries'),
            search: '<i class="fa fa-search"></i>',
            searchPlaceholder: this.$t("Search"),
            emptyTable:this.$t("No data available in table"),
            paginate: {
              next: '<i class="fas fa-chevron-right"></i>',
              previous: '<i class="fas fa-chevron-left"></i>',
            },
          },
          display:'stripe',
          serverSide: true,
          paging: true,
          ajax: function(data, callback, settings) {
              let columns = [];
              data.columns.forEach(function(item,index){
                columns.push({"data":item.data});
              });
  
              CreateAccount.exchangeList({
                draw:data.draw,
                search:data.search,
                userNo:self.userNo,
                start:data.start,
                length:data.length,
                order:data.order,
                columns:columns
              }).then((response)=>{
              if (response.status == 200) {

                self.isLoading = false;
                const responseData = response.data;
                let data = responseData.data;
                
                data.forEach(function(item) {
                  console.log(item);
                });
  
                callback({
                  draw: responseData.draw,
                  recordsTotal: responseData.recordsTotal,
                  recordsFiltered: responseData.recordsFiltered,
                  data: data,
                });
              }
            })
            .catch((err) => {
              self.checkError(err);
            });
          },
          columns: [
            { data: "apply_buyAmount", title: this.$t('Buy Amount')},
            { data: "apply_buyCcy", title: this.$t('Buy Currency')},
            { data: "apply_sellAmount", title: this.$t('Sell Amount')},
            { data: "apply_sellCcy", title: this.$t('Sell Currency')},
            { data: "created_at", title: this.$t('Created At')}
          ]
        });

        $(this.$refs.myTable).on('click', '.sub-account', this.handleSubAccount.bind(this));
      });
    },
    destroyed() {
      if (this.dataTable !== null) {
        this.dataTable.destroy(true);
      }
    },
  };
  </script>
  
<style>
@import url("https://cdn.datatables.net/2.1.5/css/dataTables.dataTables.min.css");
.dataTables_length{
  float: left;
}
div.dataTables_wrapper div.dataTables_filter{
  position: relative;
  /* margin-top: 10px; */
}
div.dataTables_filter label{
  margin: 0;
}
div.dataTables_filter svg{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  color: #899197;
}
div.dataTables_wrapper div.dataTables_filter input{
  padding-left: 35px;
  border: 1px solid #D1D4D7 !important;
  font-size: 16px !important;
}
div.dataTables_info{
  float: right;
  margin-top: 15px;
  margin-right: 5px;
  color: #899197;
  font-weight: 400;
  font-size: 14px;
}
div.dataTables_paginate.paging_simple{
  float: right;
}
div.dataTables_paginate.paging_simple ul.pagination{
  margin-top: 15px !important;
  margin-bottom: 12px !important;
}
div.dataTables_paginate.paging_simple ul.pagination li{
  background: unset !important;
}
div.dataTables_paginate.paging_simple ul.pagination li a{
  color: #2D3135 !important;
  padding: 12px 0px;
  width: 24px;
}
.dt-buttons{
  margin-bottom: 10px;
}
.dt-buttons button{
  background-color: unset !important;
  color: #2D3135;
  border: 1px solid #D1D4D7 !important;
  font-size: 14px;
  font-weight: 400;
  width: 100px;
}
</style>